import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';

//import Test		from 	'./Test'
import App		from 	'./vortex/App'
import FormTender		from 	'./vortex/FormTender'
import TenderBoard		from 	'./vortex/TendersBoard'
import AppTask	from 	'./vortex/AppTask'

import AppFormReceiveAndPayment		from 	'./vortex/model/Accounting/FormReceiveAndPayment'
import FormScopeOfWorkManager		from 	'./vortex/model/Scope/FormScopeOfWorkManager'

ReactDOM.render(<TenderBoard  />, document.getElementById('root'));
